var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"enrolling-pass-student"},[_c('PlatDataGridSiteUnit',{attrs:{"grid-id":"PeEnrollPassStudent","show-label":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }